import { alchemyRpcEndpoint } from '@shared/wallet'
import { WalletStrategy } from '@injectivelabs/wallet-strategy'
import { getInjectiveAddress } from '@injectivelabs/sdk-ts/utils'
import { CHAIN_ID, ETHEREUM_CHAIN_ID } from '@shared/utils/constant'
import { isEvmWallet, isCosmosWallet } from '@injectivelabs/wallet-base'
import type { Wallet } from '@injectivelabs/wallet-base'

export const fetchAddressFromWalletStrategy = async ({
  wallet,
  isDeposit
}: {
  wallet: Wallet
  isDeposit: boolean
}) => {
  try {
    const walletStrategy = new WalletStrategy({
      wallet,
      chainId: CHAIN_ID,
      evmOptions: {
        evmChainId: ETHEREUM_CHAIN_ID,
        rpcUrl: alchemyRpcEndpoint
      },
      strategies: {}
    })

    const addresses = await walletStrategy.enableAndGetAddresses()
    const [address] = addresses

    if (!address) {
      return undefined
    }

    // cosmos deposit returns inj address
    if (isCosmosWallet(wallet)) {
      return address
    }

    // eth deposit returns eth address so convert to inj address
    if (isDeposit) {
      return getInjectiveAddress(address)
    }

    // eth withdrawal returns eth address
    return address
  } catch {
    // silently fail
  }
}

export const fetchAddresses = async (wallet: Wallet) => {
  const walletStrategy = new WalletStrategy({
    wallet,
    chainId: CHAIN_ID,
    evmOptions: {
      evmChainId: ETHEREUM_CHAIN_ID,
      rpcUrl: alchemyRpcEndpoint
    },
    strategies: {}
  })

  const addresses = await walletStrategy.getAddresses()
  const injectiveAddresses = isEvmWallet(wallet)
    ? addresses.map(getInjectiveAddress)
    : addresses

  return injectiveAddresses
}
